<template lang="pug">
  div
    el-card.card-container(shadow="hover")
      filtro(
        placeholder="Informe o número do recibo"
        @pesquisar="pesquisar",
        @limpar="clear",
        :configuracaoFiltro="configuracaoFiltro",
        :showFiltroTipoMultiplo="filtro.showFiltroTipoProcessoMultiplo"
      )
    app-listagem(
      tituloCard="Cadastros Existentes"
      font-size-titulo-card="24px"
      header-label="Listagem de cadastros"
      :hasRowClick="true",
      :jsonHeaders="colunas",
      :jsonData="items",
      :pagina="filtro.pagina",
      :totalElements="totalElements",
      :filtro="filtro"
      @rowClick="visualizarDetalhesCadastro"
      @updateListagem="refresh",
      @changePage="changePage",
      @sort="sort",
      @executar="executar"
    )
</template>

<script>
import { mapActions } from 'vuex'
import AppListagem from '@/components/AppListagem.vue'
import Filtro from '@/components/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import BaseFiltro from '@/screens/receptor/ba/BaseFiltroCadastroProvisorio.vue'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default

export default {

  components: {
    AppListagem,
    Filtro
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('LISTAGEM_RECEPTOR_CADASTROS_PENDENTES'),
      totalProcessos: 0,
      isBusca: false,
      loading: false,
      processos: [],
      colunas: [
        { id: 0, titulo: 'Número do Recibo', propriedade: 'numeroRecibo', ordem: 1, acoes: [], type: 'icone', isIconeSimples: true, prefixoIcone: 'fal', icone: 'eye' },
        { id: 1, titulo: 'CPF/CNPJ do Interessado', propriedade: 'cpfCnpjInteressado', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Nome/Razão Social do Interessado', propriedade: 'nomeRazaoSocialInteressado', ordem: 3, acoes: [] },
        { id: 3, titulo: 'Tipo de processo', propriedade: 'tipoFormatado', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Situação', propriedade: 'statusFormatado', ordem: 5, acoes: [] }
      ],
      items: [],
      configuracaoFiltro: {
        filtroNumeroRecibo: filtro?.filtroNumeroRecibo?.LISTAGEM_RECEPTOR_CADASTROS_PENDENTES || [],
        filtroSituacao: filtro?.filtroSituacao?.LISTAGEM_RECEPTOR_CADASTROS_PENDENTES || []
      },
      totalElements: 0
    }
  },

  mounted () {
    this.init()
  },

  methods: {
    ...mapActions({
      setLoader: 'loader/setLoader',
      resetLoader: 'loader/resetLoader'
    }),

    visualizarDetalhesCadastro (data) {
      this.setLoader()
      this.$router.push({
        name: 'detalhes-cadatro-pendente-receptor',
        params: {
          idCadastro: data.numeroRecibo,
          id: data.id
        }
      }, () => {
        this.resetLoader()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-container {
    margin: 20px;
    border-radius: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/screens/receptor/ListagemCadastrosPendentes.vue